import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/store/user'
import { pinia } from '@/store/pinia'

const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
const RedisChatRoom = () => import(/* webpackChunkName: "chat" */ '../components/RedisChatRoom.vue')
const CreateDebate = () => import(/* webpackChunkName: "create" */ '../components/CreateDebate.vue')
const DebateDetail = () => import(/* webpackChunkName: "debate-detail" */ '../components/DebateDetail.vue')
const DebateJoin = () => import(/* webpackChunkName: "debate-join" */ '../components/DebateJoin.vue')
const Landing = () => import(/* webpackChunkName: "auth" */ '../views/Landing.vue')
const AuthCallback = () => import(/* webpackChunkName: "auth" */ '../views/AuthCallback.vue')
const Debate = () => import(/* webpackChunkName: "debate-lobby" */ '../views/Debate.vue')
const Profile = () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue')
const ProfileSetup = () => import(/* webpackChunkName: "profile" */ '../views/ProfileSetup.vue')
const Intro = () => import(/* webpackChunkName: "intro" */ '../views/Intro.vue')

const routes = [
  { path: '/', name: 'Home', component: Home, meta: { requiresAuth: true } },
  { path: '/debate', name: 'Debate', component: Debate, meta: { requiresAuth: true } },
  { path: '/debate/:topicId', name: 'DebateDetail', component: DebateDetail, meta: { requiresAuth: true } },
  { path: '/debate/:topicId/join', name: 'DebateJoin', component: DebateJoin, meta: { requiresAuth: true } },
  { path: '/debate/:topicId/room', redirect: to => ({ path: `/debate/${to.params.topicId}` }) },
  { path: '/create', name: 'CreateDebate', component: CreateDebate, meta: { requiresAuth: true } },
  { path: '/chat', name: 'Chat', component: RedisChatRoom, meta: { requiresAuth: true } },
  { path: '/profile', name: 'Profile', component: Profile, meta: { requiresAuth: true } },
  { path: '/profile/setup', name: 'ProfileSetup', component: ProfileSetup, meta: { requiresAuth: true } },
  { path: '/login', name: 'Login', component: Landing },
  { path: '/auth/callback', name: 'AuthCallback', component: AuthCallback },
  { path: '/intro', name: 'Intro', component: Intro }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async to => {
  const requiresAuth = to.matched.some(record => record.meta && record.meta.requiresAuth)
  const userStore = useUserStore(pinia)

  if (to.path === '/auth/callback') {
    return true
  }

  if (!userStore.initialized) {
    await userStore.initializeSession()
  }

  if (!requiresAuth) {
    if (to.path === '/login' && userStore.isLoggedIn) {
      const redirect = typeof to.query.redirect === 'string' ? to.query.redirect : '/'
      return userStore.profileCompleted ? redirect : '/profile/setup'
    }
    return true
  }

  if (userStore.isLoggedIn) {
    if (!userStore.profileCompleted && to.path !== '/profile/setup') {
      return {
        path: '/profile/setup',
        query: { redirect: to.fullPath }
      }
    }
    return true
  }

  return {
    path: '/login',
    query: { redirect: to.fullPath }
  }
})

export default router
